import React, { useState, useEffect } from "react";
import { Button, Card, Col, Descriptions, Divider, Form, Input, InputNumber, notification, Radio, Row, Select, Table, Tabs, Tag } from "antd";

import api from "../../services/api";
import { InputPreco, SelectPaginacao, SelectProduto } from "../../components";
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { FormatNumber } from "../../ValueObjects";
import { useStateValue } from "../../state";
import { CalcularImpostoItem } from "../../services/calculaImposto";
import DrawerComponentesFrete from '../../pages/componentesFrete/drawer';
import { selectPaginadoActions } from "../../actions";

export default function TabDadosGerais({ formConhecimento, tipoCTe, modalCTe, tipoServico, dadosOperacao, dadosNota, dadosProdutos, unidadeCTe, totais, componentesFrete, dadosContribuinte, dadosTomador, tipoDaMedida, setValorTotalComponentes, formAutores }) {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [formProduto] = Form.useForm();
    const [editandoComponente, setEditandoComponente] = useState(false);
    const [openDrawerCompFrete, setOpenDrawerCompFrete] = useState(false);
    const [editando, setEditando] = useState(false);
    const [compPrincipalAdd, setCompPrincipalAdd] = useState(false);
    const [listaSelectProd, setListaSelectProd] = useState([]);
    const [dadosCfop, setDadosCfop] = useState([]);
    const [listaComponentes, setListaComponentes] = useState([]);
    const [dadosProdutoImpostos, setDadosProdutoImpostos] = useState({});
    const [objetoProduto, setObjetoProduto] = useState({});
    const tipoServicoSelecionado = Form.useWatch('cte_tiposervico', formConhecimento);

    useEffect(() => {
        carregaDados();

        if (Object.keys(dadosOperacao).length > 0) {
            buscarCfopOperacao();
        }
    }, [])

    useEffect(() => {
        let valorCompPrincipal = componentesFrete.componentesFrete[0]?.ccf_valor;
        let totalValor = componentesFrete.componentesFrete.reduce((acc, item) => acc + (parseFloat(item.ccf_valor) || 0), 0);

        formProduto.setFieldsValue({
            vlr_compprincipal: valorCompPrincipal ?? 0,
            vlr_totalprestacao: totalValor
        })
        setValorTotalComponentes(totalValor);
    }, [listaComponentes, componentesFrete.componentesFrete]);

    useEffect(() => {
        if (formProduto.getFieldValue().pro_id !== undefined && parseFloat(formProduto.getFieldValue().vlr_compprincipal) > 0) {
            adicionarItem();
        } else if (formProduto.getFieldValue().pro_id !== undefined) {
            setDadosProdutoImpostos({});
        }
    }, [formProduto.getFieldValue().vlr_totalprestacao, formProduto.getFieldValue().pro_id])

    async function buscarCfopOperacao() {
        let dadosCfop = dadosOperacao.operacaocfops.filter((cfop) => cfop.opc_categoria === 1);
        let munInicial = formAutores.getFieldValue().cid_id_muninicial;
        let munFinal = formAutores.getFieldValue().cid_id_munfinal;

        if (!dadosCfop.length || !munInicial || !munFinal) {
            notification.warning({ message: "Atenção!", description: "Dados insuficientes para buscar CFOP, verifique a Operação Fiscal" });
            return;
        }

        let dadosMunInicial = (await api.get(`Cidade/Buscar/${munInicial}`)).data;
        let dadosMunFinal = (await api.get(`Cidade/Buscar/${munFinal}`)).data;
        let destinoOperacao = dadosMunFinal.estado.est_sigla === "EX" ? "3" : dadosMunInicial.estado.est_sigla === dadosMunFinal.estado.est_sigla ? "1" : "2";

        let cfopItem = dadosCfop.find(cfop => cfop.opc_destinooperacao === parseFloat(destinoOperacao)).cfop;

        if (cfopItem) {
            setDadosCfop(cfopItem)
        } else {
            notification.warning({ message: 'Atenção!', description: 'Nenhum CFOP correspondente encontrado.' });
        }
    }

    function carregaDados() {
        api.get(`ComponentesFrete/Listar`).then(
            (res) => {
                if (res.status === 200) {
                    setListaComponentes(res.data.items);
                }
            }
        ).catch(
            (erro) => {
                console.log(erro);
            }
        )
        formConhecimento.setFieldsValue({
            cte_tipocte: tipoCTe[0].key,
            cte_modal: modalCTe[0].key,
            cte_tiposervico: tipoServico[0].key,
            cte_indglobalizado: 0,
            cic_qntcarga: totais,
        })
    }

    function adicionarCompPrincipal() {
        let valor = parseFloat(formProduto.getFieldValue().vlr_compprincipal);

        if (formProduto.getFieldValue().pro_id !== undefined && !compPrincipalAdd) {
            let compPrincipal = listaComponentes.find((comp) => comp.cmf_principal === true);
            let obj = {
                cmf_sequencia: 1 + componentesFrete.componentesFrete.length,
                cmf_id: compPrincipal.cmf_id,
                cmf_descricao: compPrincipal.cmf_descricao,
                ccf_valor: valor ?? 0
            }
            let listaTemp = [...componentesFrete.componentesFrete];
            listaTemp.push(obj);
            componentesFrete.setComponentesFrete(listaTemp);
            setCompPrincipalAdd(true);
        } else if (compPrincipalAdd) {
            if (componentesFrete.componentesFrete.length > 0) {
                const novaLista = [...componentesFrete.componentesFrete];
                novaLista[0] = { ...novaLista[0], ccf_valor: valor };
                componentesFrete.setComponentesFrete(novaLista);
            }
        }
    }

    function salvandoDadosComponentes(retorno) {
        let lista = [];
        if (retorno) {
            lista.push({ name: 'cmf_id', campo: 'Codigo', value: retorno.cmf_id });
            dispatch({ type: selectPaginadoActions.CHANGE, data: { itens: lista } });

            let listaTemp = [...listaComponentes];
            listaTemp.push(retorno);
            setListaComponentes(listaTemp);
        }
    }

    function adicionarComponente() {
        let produto = dadosProdutos.dadosProdutos[0]?.pro_id;

        if (produto) {
            if (formProduto.getFieldValue().vlr_compprincipal > 0) {
                let valorAtual = parseFloat(formProduto.getFieldValue()?.ccf_valor) || 0;
                let dados = {
                    cmf_id: formProduto.getFieldValue()?.cmf_id,
                    ccf_valor: valorAtual
                };

                if (dados.cmf_id && dados.ccf_valor > 0) {
                    let dadosComp = listaComponentes.filter((item) => item.cmf_id === dados.cmf_id);
                    dados.cmf_descricao = dadosComp[0].cmf_descricao;

                    let listaTemp = [...componentesFrete.componentesFrete];

                    if (editandoComponente) {
                        dados.cmf_sequencia = formProduto.getFieldValue().cmf_sequencia
                        let index = listaTemp.findIndex(comp => comp.cmf_sequencia === dados.cmf_sequencia);

                        if (index !== -1) {
                            listaTemp[index] = dados;
                        }
                        notification.success({ message: 'Aviso!', description: 'Componente editado com sucesso' });
                    } else {
                        dados.cmf_sequencia = 1 + componentesFrete.componentesFrete.length;
                        listaTemp.push(dados);
                        notification.success({ message: 'Aviso!', description: 'Componente de Frete adicionado com sucesso' });
                    }

                    componentesFrete.setComponentesFrete(listaTemp);
                    formProduto.setFieldsValue({
                        cmf_sequencia: null,
                        cmf_id: null,
                        ccf_valor: null
                    })
                    setEditandoComponente(false);
                } else {
                    notification.warning({ message: 'Atenção!', description: 'Preencha todos os campos para adicionar' });
                }
            } else {
                notification.warning({ message: 'Atenção!', description: 'Adicione um valor ao Componente de Frete principal' });
            }
        } else {
            notification.warning({ message: 'Atenção!', description: 'Selecione um Frete antes de incluir um componente de frete' });
        }
    }

    function editarComponente(record) {
        setEditandoComponente(true);
        formProduto.setFieldsValue({
            cmf_sequencia: record.cmf_sequencia,
            cmf_id: record.cmf_id,
            ccf_valor: record.ccf_valor
        })
    }

    function cancelarEdit() {
        setEditandoComponente(false);
        formProduto.setFieldsValue({
            cmf_sequencia: null,
            cmf_id: null,
            ccf_valor: null
        })
    }

    function removerComponente(record) {
        let index = componentesFrete.componentesFrete.findIndex(comp => comp.cmf_sequencia === record.cmf_sequencia);
        let dadosTemp = [...componentesFrete.componentesFrete];

        dadosTemp.splice(index, 1)
        dadosTemp.forEach((item, index) => {
            item.cmf_sequencia = index + 1;
        })

        if (editandoComponente) {
            cancelarEdit();
        }
        componentesFrete.setComponentesFrete(dadosTemp);
    }

    function popularItem(item) {
        let itemCTe = {};
        itemCTe = {
            impostos: item.impostos,
            pro_codigo: item.pro_codigo,
            pro_descricao: item.pro_descricao,
            pro_id: item.pro_id,
            icm_id: item.icm_id,
            prg_ean: !!item.prg_ean ? item.prg_ean : item.pro_ean,
            nfi_cfop: dadosCfop.cfo_cfop,
            nfi_unidademedida: item.ump_id,
            nfi_qtde: 1,
            nfi_valorunitario: item.lpi_valorvenda ?? 0,
            cso_id: item.cso_id,
            cst_id: item.cst_id
        };
        return itemCTe;
    }

    function incluirItem(dados, listaItens) {
        listaItens.push(dados);
        dadosProdutos.setDadosProdutos(listaItens);
        notification.success({ message: 'Aviso', description: 'Produto incluído com sucesso!' });
    }

    async function adicionarItem(item = {}) {
        let dados = {}
        let listaItens = [];
        item = { ...objetoProduto };
        let p = { ...item };

        let possuiIe = !!dadosNota[0].ie_destinatario ? true : false;
        let cpfCnpjDestinatario = dadosNota[0]?.cpfCnpj_destinatario || formAutores.getFieldValue()?.cpf_destinatario || formAutores.getFieldValue()?.cnpj_destinatario;
        let fisicaJuridica = cpfCnpjDestinatario.length === 14 ? 2 : cpfCnpjDestinatario.length === 11 ? 1 : 3;
        let impostos = await CalcularImpostoItem(p.orm_id, p.cst_id, p.cso_id, p.iod_uforigem, p.iod_ufdestino, 1, formProduto.getFieldValue().vlr_totalprestacao, 0, 0, 0,
            p.iod_percicms, p.iod_percdiferimentoicms, p.iod_percicmsreducaobc, 0, 0, 0, 0, p.ncm_percentual, fisicaJuridica, 0, possuiIe, 0);

        item.impostos = impostos;
        setDadosProdutoImpostos(item);

        if (dadosProdutos.dadosProdutos.length === 0) {
            dados = popularItem(item);
            dados.numeroItem = listaItens.length + 1;
            incluirItem(dados, listaItens);
        }
    }

    async function buscarProduto(produto) {
        if (produto !== undefined) {
            let dadosDoc = dadosNota[0];
            let listaItens = [...listaSelectProd];
            let prod = listaItens.filter((item) => item.key === produto)[0];

            let destinoOperacao = (!!dadosTomador.cta_siglauf && !!dadosContribuinte.est_sigla && (dadosTomador.cta_siglauf === dadosContribuinte.est_sigla) ? '1' : dadosTomador.cta_siglauf === "EX" ? '3' : '2');
            let ufDest = dadosDoc.enderecosDest?.[0]?.est_sigla || dadosContribuinte.est_sigla;
            let inscEstadual = !!dadosDoc.ie_destinatario ? `&inscEstadual=${dadosDoc.ie_destinatario}` : '';
            let objProd = (await api.get(`Produto/BuscarDadosProduto?IdProduto=${prod.pro_id}&ufDestino=${ufDest}`
                + `&operacaoCodigo=${dadosOperacao.ope_id}&ufOrigem=${dadosContribuinte.est_sigla}&tipoContribuinte=${dadosContribuinte.loc_tipocontribuinte}`
                + `&empresaEnquadramento=${dadosContribuinte.emp_regimetributario}&destinoOperacao=${destinoOperacao}${''}${inscEstadual}`
            )).data[0];

            setObjetoProduto(objProd);
        } else {
            setObjetoProduto({});
            setDadosProdutoImpostos({});
            dadosProdutos.setDadosProdutos([]);
            setCompPrincipalAdd(false);
            componentesFrete.setComponentesFrete([]);
        }
    }

    function verificaChave(value) {
        let chave = value.currentTarget.value;
        let somenteNumeros = chave.replace(/\D/g, '');

        if (chave !== somenteNumeros) {
            notification.warning({
                message: 'Atenção!',
                description: 'Chave da Nota deve conter apenas números'
            });
            formConhecimento.setFieldsValue({ cte_chctesubcontratacao: somenteNumeros });
            return;
        }

        if (somenteNumeros.length >= 22) {
            let modelo = somenteNumeros.slice(20, 22);
            if (modelo !== '57') {
                formConhecimento.setFieldsValue({ cte_chctesubcontratacao: undefined });
                notification.warning({
                    message: 'Atenção!',
                    description: 'Modelo da Chave deve ser 57'
                });
                return;
            }
        }
    }

    return (
        <div className="pages-col">
            <Form layout="vertical" form={formConhecimento} name="formDadosGerais">
                <Row gutter={[8, 0]} style={{ marginTop: '10px' }}>
                    <Col xs={12} sm={12} md={6} lg={6} xl={7}>
                        <Form.Item label="Tipo do CTe" name="cte_tipocte" rules={[{ required: true, message: 'Informe o tipo do CTe' }]}>
                            <Select placeholder="Selecione o Tipo do CTe" allowClear disabled>
                                {tipoCTe.map((item) => (
                                    <Select.Option value={item.key} key={item.key}>{item.value}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={7}>
                        <Form.Item label="Modal" name="cte_modal" rules={[{ required: true, message: 'Informe o modal do CTe' }]}>
                            <Select placeholder="Selecione o Modal" allowClear disabled>
                                {modalCTe.map((item) => (
                                    <Select.Option value={item.key} key={item.key}>{item.value}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={7}>
                        <Form.Item label="Tipo Serviço" name="cte_tiposervico" rules={[{ required: true, message: 'Informe o tipo de serviço' }]}>
                            <Select placeholder="Selecione o Tipo de Serviço" allowClear defaultValue={0}>
                                {tipoServico.map((item) => (
                                    <Select.Option value={item.key} key={item.key}>{item.value}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={3}>
                        <Form.Item label="CTe Globalizado" name="cte_indglobalizado">
                            <Radio.Group defaultValue={0}>
                                <Radio value={1}>Sim</Radio>
                                <Radio value={0}>Não</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    {tipoServicoSelecionado === 1 && (<Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <Form.Item label="Chave do CTe Subcontratação" name='cte_chctesubcontratacao' rules={[{ required: true, message: 'Informe a Chave' }]}>
                            <Input placeholder="Informe a chave do CTe" maxLength={44} onBlur={(value) => verificaChave(value)} />
                        </Form.Item>
                    </Col>
                    )}
                </Row>
                <Row gutter={[8, 0]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item label="Descrição do Produto Predominante" name="cte_prodpredominante" rules={[{ required: true }]}>
                            <Input placeholder="Informe o Produto Predominante" maxLength={255} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row align="middle" style={{ marginTop: '10px' }}>
                    <Divider orientation="left">Informações Quantidade de Cargas</Divider>
                </Row>
                <Row gutter={[8, 0]}>
                    <Col xs={24} sm={7} md={6} lg={10} xl={8}>
                        <Form.Item label="Unidade de Carga" name="cic_unit" rules={[{ required: true, message: 'Informe a unidade de carga' }]}>
                            <Select placeholder="Selecione a Unidade de Carga" allowClear>
                                {unidadeCTe.map((item) => (
                                    <Select.Option value={item.key} key={item.key}>{item.value}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={10} xl={8}>
                        <Form.Item label="Tipo de Medida" name="cic_tipomedida" rules={[{ required: true, message: 'Informe o tipo de medida' }]}>
                            <Select placeholder="Selecione o Tipo da Medida" allowClear>
                                {tipoDaMedida.map((item) => (
                                    <Select.Option value={item.key} key={item.key}>{item.value}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={5} md={6} lg={4} xl={8}>
                        <InputPreco
                            name="cic_qntcarga"
                            label="Quantidade de Carga"
                            rules={[{ required: true, message: 'Informe a quantidade de carga' }]}
                            precision={4} maxLength={15}
                            placeholder="Informe a Quantidade de Carga"
                        />
                    </Col>
                </Row>
            </Form>
            <Form layout="vertical" form={formProduto} name="formProdutos">
                <Row align="middle" style={{ marginTop: '10px' }}>
                    <Divider orientation="left">Prestação de Serviço</Divider>
                </Row>
                <Row gutter={[8, 0]}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={8}>
                        <Form.Item label="Selecione o Frete" name="pro_id">
                            <SelectProduto valueKey={true} detalhes={true}
                                placeholder="Selecione o Frete"
                                name="pro_id"
                                form={formProduto}
                                allowClear={true}
                                onChange={(dados) => { buscarProduto(dados) }}
                                ordem={"pro_descricao"}
                                setListaDados={setListaSelectProd}
                                filtroExtra={`&ProdutoFrete=true`}
                                exibirValor={false}
                            />
                        </Form.Item>
                    </Col>
                    <Col>
                        <InputPreco label="Valor do Frete (R$)" name="vlr_compprincipal" disabled={formProduto.getFieldValue().pro_id === undefined} onBlur={() => adicionarCompPrincipal()} />
                    </Col>
                    <Col>
                        <InputPreco label="Valor Total da Prestação (R$)" name="vlr_totalprestacao" disabled />
                    </Col>
                </Row>
                <Row align="middle" style={{ marginTop: '10px' }}>
                    <Divider orientation="left">Componentes de Frete</Divider>
                </Row>
                <Row gutter={[8, 0]}>
                    <Form.Item hidden label="Sequência" name="cmf_sequencia">
                        <InputNumber disabled />
                    </Form.Item>
                    <Col xs={24} sm={11} md={12} lg={12} xl={8}>
                        <Form.Item label="Componente" name="cmf_id">
                            <SelectPaginacao url="ComponentesFrete/Listar"
                                allowClear={true}
                                selecionarRegUnico={"cmf_id"}
                                nameLabel="cmf_descricao"
                                nameValue="cmf_id"
                                placeholder="Selecione um Componente de Frete"
                                form={formProduto}
                                funcaoIncluir={() => setOpenDrawerCompFrete(true)}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={5} md={4} lg={4} xl={4}>
                        <InputPreco label="Valor do Componente" name="ccf_valor" />
                    </Col>
                    <Col xs={12} sm={4} md={4} lg={4} xl={3} className="add-button">
                        {editandoComponente ?
                            <Button icon={<CheckOutlined />} type="primary" onClick={() => adicionarComponente()} >
                                Salvar
                            </Button> :
                            <Button icon={<PlusOutlined />} type="primary" onClick={() => adicionarComponente()} >
                                Adicionar
                            </Button>
                        }
                    </Col>
                    <Col xs={12} sm={4} md={4} lg={4} xl={3} className="add-button">
                        {editandoComponente &&
                            <Button icon={<CloseOutlined />} onClick={() => cancelarEdit()} >
                                Cancelar
                            </Button>
                        }
                    </Col>
                </Row>
                <div>
                    <Table columns={[
                        {
                            title: '',
                            align: 'center',
                            width: 75,
                            render: (_, record, index) => {
                                return (
                                    <Tag color={index === 0 ? "processing" : "default"} className="w-100">
                                        <b>{record?.cmf_sequencia}</b>
                                    </Tag>
                                )
                            }
                        },
                        {
                            title: 'Descrição',
                            render: ({ cmf_descricao }) => (
                                <b>{cmf_descricao}</b>
                            )
                        },
                        {
                            title: 'Valor (R$)',
                            align: 'right',
                            width: 100,
                            render: ({ ccf_valor }) => (
                                <b>{FormatNumber(ccf_valor, true)}</b>
                            )
                        },
                        {
                            title: 'Ações',
                            align: 'center',
                            width: 65,
                            dataIndex: '',
                            key: 'x',
                            fixed: 'right',
                            render: (_, record, index) => {
                                const isFirstItem = index === 0;
                                return (
                                    <div>
                                        <Row align="middle" justify="center" gutter={[5, 0]}>
                                            <Col>
                                                <Button icon={<EditOutlined />} onClick={() => editarComponente(record)} disabled={isFirstItem} />
                                            </Col>
                                            <Col>
                                                <Button icon={<DeleteOutlined />} onClick={() => removerComponente(record)} disabled={isFirstItem} />
                                            </Col>
                                        </Row>
                                    </div>
                                )
                            }
                        }
                    ]}
                        locale={{
                            emptyText: (
                                <Row>
                                    <Col span={24}>
                                        <Divider orientation="center">
                                            <ExclamationCircleOutlined /> Selecione um Produto para incluir um componente
                                        </Divider>
                                    </Col>
                                </Row>
                            )
                        }}
                        dataSource={componentesFrete.componentesFrete}
                        pagination={false}
                        scroll={{ y: 100 }}
                    />
                </div>
                <Row gutter={[8, 0]} align="middle" style={{ marginTop: '10px' }}>
                    <Col span={12}>
                        <Card title="Informações Relativas aos Impostos">
                            <Row align="middle">
                                <Col>
                                    <Descriptions column={1} size="small">
                                        <Descriptions.Item label="CFOP">
                                            <b>{dadosCfop.cfo_cfop} - {dadosCfop.cfo_descricao}</b>
                                        </Descriptions.Item>
                                    </Descriptions>
                                </Col>
                            </Row>
                            <div style={{ marginTop: "12px" }}>
                                <Tabs type="card">
                                    <Tabs.TabPane tab="ICMS" key="1">
                                        <Row>
                                            <Col>
                                                <Descriptions column={1} size="small">
                                                    <Descriptions.Item>
                                                        <b>{dadosProdutoImpostos.icm_descricao ?? "ICMS não Informado"}</b>
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label="Valor da BC do ICMS">
                                                        <b>{dadosProdutoImpostos.impostos ? FormatNumber(dadosProdutoImpostos.impostos.retornoICMS.ret_baseIcms, true) : "Não Informado"}</b>
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label="Alíquota do ICMS">
                                                        <b>{dadosProdutoImpostos.impostos ? dadosProdutoImpostos.impostos.retornoICMS.ret_aliquotaIcms + "%" : "Não Informado"}</b>
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label="Valor do ICMS">
                                                        <b>{dadosProdutoImpostos.impostos ? FormatNumber(dadosProdutoImpostos.impostos.retornoICMS.ret_valorIcms, true) : "Não Informado"}</b>
                                                    </Descriptions.Item>
                                                </Descriptions>
                                            </Col>
                                        </Row>
                                    </Tabs.TabPane>
                                </Tabs>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <DrawerComponentesFrete editando={{ editando, setEditando }} openDrawerCompFrete={openDrawerCompFrete} setOpenDrawerCompFrete={setOpenDrawerCompFrete} cadComp={false} retornoSalvar={salvandoDadosComponentes} />
            </Form>
        </div>
    )
}